import { createSelector } from 'reselect';
import _ from 'lodash';
import { pendingResponse } from '../../../fetchStatus';
import { sessionSelector } from './index';

export const cartResponseSelector = createSelector([sessionSelector], session => session.cart || pendingResponse);

export const cartSelector = createSelector([cartResponseSelector], cartResponse => _.get(cartResponse, 'data') || {});
